export default __webpack_public_path__ + "static/media/location_preview_s5_mechs_vs_monsters.e04b677b.svg";